export default "__VITE_ASSET__DGXjpiQA__"